<template>
  <div id="tf-bodorhub" class="text-center">
    <div class="section-title text-center center">
      <h2>{{ $t("home.look") }}<strong> BodorHUB</strong></h2>
      <div class="line">
        <hr />
      </div>
      <div class="clearfix"></div>
      <small
        ><em> {{ $t("home.hubin") }} </em></small
      >
    </div>
    <div class="projectsBox">
      <div id="first" class="flexImgBox">
        <figure class="flexImgBox_figure">
          <img :src="imgsUrl[0]" alt="" width="480" height="383" />
        </figure>
        <div class="info">
          <h3>{{ $t("home.acquisition") }}</h3>
          <p>
            {{ $t("home.acquisitionin") }}
          </p>
        </div>
      </div>
      <div id="second" class="flexImgBox">
        <figure class="flexImgBox_figure">
          <img :src="imgsUrl[1]" alt="" width="480" height="383" />
        </figure>
        <div class="info">
          <h3>{{ $t("home.simple") }}</h3>
          <p>
            {{ $t("home.simplein") }}
          </p>
        </div>
      </div>
      <div id="third" class="flexImgBox">
        <figure class="flexImgBox_figure">
          <img :src="imgsUrl[2]" alt="" width="480" height="383" />
        </figure>
        <div class="info">
          <h3>{{ $t("home.instant") }}</h3>
          <p>{{ $t("home.instantin") }}</p>
        </div>
      </div>
      <div id="fourth" class="flexImgBox">
        <figure class="flexImgBox_figure">
          <img :src="imgsUrl[3]" alt="" width="480" height="383" />
        </figure>
        <div class="info">
          <h3>{{ $t("home.private") }}</h3>
          <p>{{ $t("home.privatein") }}</p>
        </div>
      </div>
    </div>
    <div style="margin: 30px">
      <small
        ><em> {{ $t("home.hubin2") }} </em></small
      >
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const imgsUrl = ref([
  require("@/assets/img/hub/1.jpg"),
  require("@/assets/img/hub/2.jpg"),
  require("@/assets/img/hub/3.jpg"),
  require("@/assets/img/hub/4.jpg"),
]);
</script>

<style scoped>
.flexImgBox {
  width: 25%;
  perspective: 1700px;
  -webkit-perspective-origin: 0 50%;
  -moz-perspective-origin: 0 50%;
  perspective-origin: 0 50%;
  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  transform-style: preserve-3d;
  background: #2a2a2a;
  display: flex;
  overflow: hidden;
}
.flexImgBox_figure {
  z-index: 2;
  overflow: hidden;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.info {
  position: relative;
  z-index: 10;
  width: 100%;
  height: 100%;
  text-align: left;
  color: #9b9b9b;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 380px;
  transform-origin: 0 0;
  transform: rotateY(-90deg);
  transition: transform 0.4s, opacity 0.1s 0.3s;
  width: 50%;
  min-width: 240px;
  opacity: 0;
  background-color: #2a2a2a;
  color: #9b9b9b;
  box-sizing: border-box;
  padding: 25px;
}
.info h3 {
  color: #ffffff;
}
.info p {
  margin-top: 14px;
}
.flexImgBox img {
  transition: transform 0.4s;
  min-height: 100.1%;
  min-width: 100%;
  max-width: none;
  flex-shrink: 0;
}
.flexImgBox:hover img {
  transform: translateX(25%);
}
.flexImgBox:hover .info {
  opacity: 1;
  transform: rotateY(0deg);
  transition: transform 0.4s, opacity 0.1s;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.projectsBox {
  width: 100%;
  display: flex;
}
@media (max-width: 767px) {
  .projectsBox {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
  .flexImgBox {
    width: 100%;
  }
  h2 {
    line-height: 50px;
  }
}
figure {
  margin: 0px;
}
</style>
